import { useLocation } from 'react-router-dom';
import './Navbar.css';

const TITLES = {
  '/dashboard':  { title: 'Dashboard',     sub: 'Overview of your workspace' },
  '/clients':    { title: 'Clients',        sub: 'Manage your client relationships' },
  '/projects':   { title: 'Projects',       sub: 'Track design & execution projects' },
  '/tasks':      { title: 'Tasks',          sub: 'Kanban board & task management' },
  '/payments':   { title: 'Financials',     sub: 'Company financial health & insights' },
  '/attendance': { title: 'Attendance',     sub: 'Team attendance & check-ins' },
  '/activity':   { title: 'Activity Logs',  sub: 'Notes, calls & follow-ups' },
  '/settings':   { title: 'Settings',       sub: 'Account & system preferences' },
};

export default function Navbar({ onMenuClick }) {
  const { pathname } = useLocation();
  const page = TITLES[pathname] || { title: 'Tatsavi Spaces', sub: '' };
  const now  = new Date().toLocaleDateString('en-IN', { weekday:'long', day:'numeric', month:'long', year:'numeric' });

  return (
    <header className="topnav">
      <button
        type="button"
        className="topnav-menu"
        aria-label="Open navigation"
        onClick={onMenuClick}
      >
        <span />
        <span />
        <span />
      </button>
      <div className="topnav-left">
        <h2 className="topnav-title">{page.title}</h2>
        {page.sub && <p className="topnav-sub">{page.sub}</p>}
      </div>
      <div className="topnav-right">
        <span className="topnav-date">{now}</span>
      </div>
    </header>
  );
}
